import { defineRule } from 'vee-validate';
import { required, email, min, max } from '@vee-validate/rules';
import dayjs from 'dayjs';

defineRule('required', (value, [target]) => {
  if (required(value)) {
    return true;
  }

  return `${target}は入力必須です`;
});

defineRule('email', (value) => {
  if (email(value) && required(value)) {
    return true;
  }

  return 'メールアドレスが正しくありません。';
});

defineRule('password', (value) => {
  if (required(value) && min(value, { length: 6 }) && max(value, { length: 30 })) {
    return true;
  }

  return 'パスワードは6文字以上30文字以下にしてください。';
});

defineRule('confirmed', (value, [target], ctx) => {
  if (value === ctx.form[target]) {
    return true;
  }

  return 'パスワードが一致しません。';
});

defineRule('after', (value, [target], ctx) => {
  // valueがないor比較対象が指定されていない場合はtrue扱いにする
  if (!value || !ctx.form[target]) {
    return true;
  }

  if (dayjs(value).isAfter(dayjs(ctx.form[target]))) {
    return true;
  }

  return '終了は開始より後を指定してください。';
});
